import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const isCursorInElement = (
  event: React.MouseEvent,
  element: HTMLElement | null
) => {
  if (!element) return false;
  const rect = element.getBoundingClientRect() || {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  };
  const x = event.clientX;
  if (x < rect.left || x >= rect.right) return false;
  const y = event.clientY;
  if (y < rect.top || y >= rect.bottom) return false;
  return true;
};

export const getOrdinal = ({ number }: { number: number }) =>
  `${number}${['st', 'nd', 'rd'][((((number + 90) % 100) - 10) % 10) - 1] || 'th'}`;
